// extracted by mini-css-extract-plugin
module.exports = {"root":"ToolboxContentEditor_root__2nvBB","cardLeft":"ToolboxContentEditor_cardLeft__1pS8P","cardRight":"ToolboxContentEditor_cardRight__2_C8t"};